import { ThemeProvider } from '@material-ui/styles';
import {  Container, makeStyles,  Typography,createTheme,TextField, TableContainer, LinearProgress, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react'
import { useState } from 'react'
import { CoinList } from '../config/api';
import { CryptoState } from '../CryptoContext';
import { Pagination } from '@material-ui/lab';
const darkTheme = createTheme({
  palette: {
    primary:{
      main: '#fff'
    },
    type: 'dark',
  },
});
 const useStyles=makeStyles({
  row:{
     cursor:'pointer',
     backgroundColor:'black',
     "&:hover":{
      backgroundColor:'#131111'
    }
  }

 })
const Coinstabel = () => {


  const numberwithcommas=(x)=>{
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  const classes=useStyles();
  const navigate = useNavigate();
  const [coins, setcoins] = useState([]);
  const [loading, setloading] = useState(true);
  const [search, setsearch] = useState('');
  const [page, setpage] = useState(1)
  const {currency,symbol}=CryptoState()

  const fetchcoins= async()=>{
     const {data}=await axios(CoinList(currency))
     setcoins(data)
     setloading(false)
    
  }
  //console.log(coins)
  useEffect(() => {
     fetchcoins()
  }, [currency])
  
  const handlesearch=()=>{
      return(  coins.filter((coin)=>{
      return(coin.name.toLowerCase().includes(search) || coin.symbol.toLowerCase().includes(search) )
     }))
  }

  return (
      <ThemeProvider theme={darkTheme} >
      <Container style={{textAlign:'center'}} >
        <Typography variant="h4" style={{margin:'18px',}} >
         Crypto Prices by Market Cap  </Typography>
    <TextField label='Search for crypto currency' variant='outlined' style={{marginBottom:'20px',width:'100%'}} onChange={(e)=>{setsearch(e.target.value) }} />

     <TableContainer>
     {loading ?(
            <LinearProgress style={{backgroundColor:'gold'}} ></LinearProgress>
          ):(<Table>
             <TableHead style={{backgroundColor:"#EEBC1D"}} >
              <TableRow>
                {["Coin","Price","24h Change","Market Cap"].map((head)=>{
                  return(  <TableCell style={{color:'black',fontWeight:'700'}} key={head} align={head==="Coin"?'':'right'}>
                      {head}
                  </TableCell>)
                })}
              
              </TableRow>

             </TableHead>

                  <TableBody>
                  {handlesearch().slice((page-1)*10,(page-1)*10+10).map((row)=>{
                    return (<TableRow onClick={()=>{
                      return( navigate(`/coins/${row.id}`) )
                    }} className={classes.row} key={row.id} > 
                    <TableCell scope='row' component='th' style={{display:'flex',gap:'15px'}} align='left' >
                    <div style={{display:'flex',flexDirection:'column'}} >
                    <img src={row.image} alt={row.name} height='50px' style={{marginBottom:'15px'}} />
                    
                    <span style={{fontSize:'26px',textTransform:'uppercase'}}>{row.symbol} </span> 
                    <span style={{color:'darkgray'}} >{row.name}</span>
                    
                    </div>
                    </TableCell>

                 <TableCell align='right'  >
                  {symbol} {" "}
                  {numberwithcommas(row.current_price)}
                  </TableCell>

                  <TableCell align='right' >
                  {numberwithcommas(row.price_change_percentage_24h.toFixed(2))}%
                  </TableCell>

                  <TableCell align='right' >
                  {numberwithcommas(row.market_cap.toString().slice(0,-6))}
                  </TableCell>
    
                  </TableRow> )
                  })}
                  </TableBody>
          </Table> )}
      
      </TableContainer>

      <Pagination 
       style={{padding:'20px',display:'flex',justifyContent:'center',width:'100%'}}
      count={(handlesearch()?.length/10).toFixed(0)}
      onChange={(_,value)=>{
         setpage(value)
        window.scroll(0,450)
      }}
      />
      </Container>

      </ThemeProvider>
  )
}

export default Coinstabel